module.exports = "mutation ($data: ResidentialAccountCreate!) {\n  ResidentialAccountCreate(data: $data) {\n    id\n  }\n}\n"